// Copyright 2024, 2026 - Hewlett Packard Enterprise Company
/* eslint-disable import/prefer-default-export */
import {
  REDIRECT_URI_KEY,
  REDIRECT_SEARCH_PARAMS_KEY,
  DEV_AUTHORITY_URL,
  OIDC_AUTHORITY,
} from '../constants/authConst';

export function isDevEnvAuth() {
  return OIDC_AUTHORITY === DEV_AUTHORITY_URL;
}

export function postLoginRedirect(history) {
  const redirectTo = window.sessionStorage.getItem(REDIRECT_URI_KEY) || '/';
  window.sessionStorage.removeItem(REDIRECT_URI_KEY);
  const searchParams =
    window.sessionStorage.getItem(REDIRECT_SEARCH_PARAMS_KEY) || '';
  window.sessionStorage.removeItem(REDIRECT_SEARCH_PARAMS_KEY);

  const newUrl = searchParams ? `${redirectTo}?${searchParams}` : redirectTo;
  history.replace(newUrl);
}

function sessionKeyStore() {
  let sessionKey = '';
  return {
    get: () => sessionKey,
    set: key => {
      if (sessionKey === '') {
        sessionKey = key;
      }
    },
  };
}

export const sessionKey = sessionKeyStore();
